var r=function(r){return"string"==typeof r},t=function(r){return r.split("").reduce((function(r,t){return r+t.charCodeAt(0)}),0)};export{t as getChartCodeAtSum,r as isString};
